import Result from "@/core/common/Result";

export type PodeVisualizarPesquisaCSATInput = {
  pesquisa: string;
};

export type PodeVisualizarPesquisaOutput = {
  id: string;
  podeVisualizar: boolean;
};

export interface IPodeVisualizarPesquisaCSATUseCase {
  podeVisualizar(
    params: PodeVisualizarPesquisaCSATInput
  ): Promise<Result<PodeVisualizarPesquisaOutput>>;
}

export const podeVisualizarPesquisaCSATUseCaseDI =
  "podeVisualizarPesquisaCSATUseCaseDI";
